// extracted by mini-css-extract-plugin
export default {"UsersStats":"UsersStats_UsersStats__oyW0A","UsersStats__heading":"UsersStats_UsersStats__heading__gReSU","UsersStats__count":"UsersStats_UsersStats__count__yUjtb"};